import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NaturezaJuridicaFormControlComponent } from './natureza-juridica-form-control.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        NaturezaJuridicaFormControlComponent
    ],
    exports: [
        NaturezaJuridicaFormControlComponent
    ]
})
export class NaturezaJuridicaFormControlModule { }
